import angular from 'angular';
import controller from './tabs.controller';
import template from './tabs.html';
import fbtemplate from './builder/preview.html';
import TabsComponent from './tabs.component';
import './tabs.scss';

const tabsConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('tabs', {
		onEdit: /* @ngInject */     (/** @type {any} */ $scope) => {
			$scope.component.active = 0;
			$scope.removeTab = (/** @type {number} */ index) => {
				$scope.component.tabs.splice(index, 1);
			};
			$scope.addTab = () => {
				$scope.component.tabs.push({
					components: [],
					title:      'New tab',
					disabled:   false,
				});
			};
		},
		title:                      'Tabs',
		template,
		fbtemplate,
		group:                      'layout',
		children:                   false,
		selectable:                 true,
		settings:                   new TabsComponent(),
		icon:                       'fa fa-clone',
		noDndOverlay:               true,
		confirmRemove:              true,
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/tabs/display.html',
			},
			{
				name:     'API',
				template: 'templates/components/common/api2.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller,
	});
};

export default angular.module('app')
	.config(tabsConfig);
